import React from "react";
import { Calendar, CalendarPlus, MoreHorizontal, Share } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { BusinessReportOutcomeDetails } from "@/modules/snapshots/businessReports.types";
import { BusinessReportOutcomeShareModal } from "../modals/shareModal";

interface Props {
  businessReportOutcome: BusinessReportOutcomeDetails;
  canShare: boolean;
  onViewEvent?: () => void;
  onCreateEvent?: () => void;
}

export const BusinessReportOutcomeHeaderMenu: React.FC<Props> = ({
  businessReportOutcome,
  canShare,
  onViewEvent,
  onCreateEvent,
}) => {
  const [isShareOpen, setIsShareOpen] = React.useState(false);

  if (!canShare && !onViewEvent && !onCreateEvent) {
    return null;
  }

  return (
    <>
      {isShareOpen && (
        <BusinessReportOutcomeShareModal
          setIsOpen={setIsShareOpen}
          isOpen={isShareOpen}
          businessReportOutcome={businessReportOutcome}
        />
      )}

      <DropdownMenu modal={false}>
        <DropdownMenuTrigger asChild>
          <Button type="button" variant="outline" size="icon" aria-label="More actions">
            <MoreHorizontal className="size-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          align="end"
          sideOffset={8}
          className="w-56 [&_[role=menuitem]>svg]:size-4 [&_[role=menuitem]>svg]:shrink-0 [&_[role=menuitem]]:gap-2.5"
        >
          {canShare && (
            <DropdownMenuItem onSelect={() => setIsShareOpen(true)} className="cursor-pointer">
              <Share />
              Share
            </DropdownMenuItem>
          )}
          {onViewEvent && (
            <DropdownMenuItem onSelect={onViewEvent} className="cursor-pointer">
              <Calendar />
              View Event
            </DropdownMenuItem>
          )}
          {onCreateEvent && (
            <DropdownMenuItem onSelect={onCreateEvent} className="cursor-pointer">
              <CalendarPlus />
              Create event
            </DropdownMenuItem>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
};
